import { defineMessages } from 'react-intl';

export const FLAME_CHART_TOOLTIP_MESSAGES = defineMessages({
  duration: {
    id: 'PvxiDAHj1Za2svSx',
    defaultMessage: 'Duration',
    description:
      'Value column header in the flame chart tooltip, labelling the duration of each segment.',
  },
});
